<template>
  <div class="full-width-overflow-y" :style="styleObj" >
    <HomeHeader
        :returnLabel="returnLabel"
        :useChatBtn="true"
        @clickBackBtn="return3DCity"
        @clickChatBtn="openChatPart"
        v-if="false !== fullScreen"
    />

    <div :class="fullScreen === false ? 'page-part-full' : 'page-part'" v-loading="loading" v-if="viewName === 'index' " >

      <searchMainComponent
            :type="searchTypeTag"
            @goShop="goShopPosition"
        />


    </div>

    <div class="page-part" v-loading="loading" v-show="viewName !== 'index'" v-if="false !== fullScreen">
<!--      <iframe v-show="viewName === 'chat'" ref="chatRoomIframeDom" :src="chatRoomUrl" seamless="seamless"></iframe>-->



      <div v-if="viewName === 'setting'" style="width: 100%; height: 100%">
        <settingComponent @logout-complete="logoutCheck" />
      </div>


      <div v-if="viewName === 'hall'" style="width: 100%; height: 100%">
        <HallManager
            @clickReturnBtn="return3DCity"
            :showReturnBtn="fullScreen == false"
        />
      </div>

    </div>

    <el-dialog
        v-model="openShopVisible"
        :title="i18n.tkey('lang_open_shop_3d')"
        :width="myUtil.isMobile() ? '90%' : '600px'"
        align-center
        destroy-on-close
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
      <companyShopInfoEditor :tag="'edit'" :countrycode="userInfoRef.country" @saveComplete="saveShopCallback" />
    </el-dialog>

    <div v-if="reLogin === true" style="width: 1000px; height: 1000px; position: fixed; top: 200vh; left: 0;">
      <LoginComponent
          @login-check-complete="loginCheck"
      />
    </div>

  </div>
</template>

<script setup>
import SettingComponent from "@/components/phone/settingComponent.vue";
import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
import LoginComponent from "@/components/loginComponent.vue";
import {inject, onBeforeMount, ref, toRef, getCurrentInstance, computed, provide, nextTick} from "vue";
import myUtil from "@/util/util";
import cardApi from "@/request/api";
import {useUserinfo} from "@/stores/userinfo";
import CompanyShopInfoEditor from "@/components/shopopee/company/companyShopInfoEditor.vue";
import {useCompanyinfo} from "@/stores/companyinfo";
import companyApi from "@/request/companyApi";
import HallManager from "@/components/shopopee/hall/hallManager.vue";
import searchMainComponent from '@/components/phone/searchMainComponent.vue'
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'

library.add(faGlobe)

const props = defineProps(["fullScreen"])
const emits = defineEmits(["go-other-view"])

const i18n = inject("i18n")
const reload = inject("reload");
const userInfoRef = toRef(useUserinfo())
//響應機制的companyinfo
const companyInfoRef = toRef(useCompanyinfo())
const { proxy } = getCurrentInstance()
const chatRoomUrl = ref(null)

const loading = ref(false)

const iconCol = ref(24)
const infoCol = ref(24)

const styleObj = ref({})

const userCard = ref(null)
const departmentData = ref(null)

const viewName = ref("index")
const openShopVisible = ref(false)
const reLogin = ref(false)

//首页搜索内容的类别
const searchTypeTag = ref("agentmaterial")
//店铺控制室使用的company
const shopCompanyObj = ref(null)

const showIconPart = ref(true)

const returnLabel = computed(() => {
  let name = "3dShopopee"

  if (viewName.value != "index"){
    name = i18n.tkey('lang_return')
  }

  return name
})


function goShopPosition(wa, siojournal, islandid){
  emits("goShopPosition", wa, siojournal, islandid)
}
function return3DCity(){
  window.location.href=`${proxy.$ShopopeeUrl}index`
}

function openChatPart(){
  viewName.value = "chat"
}

function getInfo(){
  loading.value = true

  const request = cardApi.queryDepartMemberwork
  const params = request.getParams()

  request.send(params, (res) => {
    loading.value = false

    if (res.code == 200){
      const obj = res.detail

      if (null != obj){
        if (null != obj.additionalrecord11){
          if (null != obj.additionalrecord11.addremark1){
            obj.additionalrecord11 = JSON.parse(obj.additionalrecord11.addremark1)
          }
        }

        if (myUtil.isNotEmpty(obj.id)){
          myUtil.mergeObj(obj, companyInfoRef.value)
        }

        try {
          userCard.value = obj.list[0].memberworkList[0]
        }catch (e){
          console.log(e)
        }

        let list = []

        if (obj.list.length > 0){
          // list.push(obj.list[0])
          list = obj.list

          if (null == departmentData.value){
            departmentData.value = list
          }

        }

      }

    }
  })

}

function clickView(view) {
  if(view === "openShop"){
    openShopDialog()
    return
  }

  if (props.fullScreen === false){
    emits('go-other-view', view)

  }else{
    if (view === "mycard"){
      proxy.$router.push({name: "myCard"})
    }else if(view === "shop"){
      proxy.$router.push({name: "shopController"})
    }else if(view === "myQuotation"){
      proxy.$router.push({name: "myQuotation"})
    }else if(view === "mallManager"){
      proxy.$router.push({name: "mallManager"})
    }else if(view === "islandManager"){
      proxy.$router.push({name: "islandManager"})
    }else{
      viewName.value = view
    }
  }

}

function logoutCheck(){
  chatRoomUrl.value = null

  proxy.$router.push({name: "login"})
}

function openShopDialog(){
  openShopVisible.value = true
}

function saveShopCallback(){
  myUtil.confirmSuccess(
      i18n.tkey("lang_open_shop_success"),
      () => {
        loading.value = true
        reLogin.value = true
      },
      () => {
        loading.value = true
        reLogin.value = true
      }
  )
}

function loginCheck(){
  reload()
}

function setShopCompanyObj(obj){
  shopCompanyObj.value = obj

  showIconPart.value = false
  nextTick(() => {
    showIconPart.value = true
  })
}

function getShopCompanyObj(){
  return shopCompanyObj.value
}

function getCompanyInfo(){
  loading.value = true

  const request = companyApi.getCompanyInfo
  const params = request.getParams()

  params.companycode = userInfoRef.value.selectCompanycode

  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
      shopCompanyObj.value = res.detail

    }
  })

}


provide('shopControlFunc', {
  setShopCompanyObj,
  getShopCompanyObj,
})

onBeforeMount(() => {
  if (myUtil.isMobile()){
    iconCol.value = 16
    infoCol.value = 8
  }else{
    iconCol.value = 24
    infoCol.value = 24
  }

  if (props.fullScreen !== false){
    styleObj.value = {
      width: `${window.innerWidth}px`,
      height: `${window.innerHeight}px`
    }

    chatRoomUrl.value = `${proxy.$ShopopeeUrl}/enterChatRoom?login=${userInfoRef.value.login}&password=${userInfoRef.value.password}&tag=3dshopopee`

  }

  if (userInfoRef.value.companycode !== userInfoRef.value.selectCompanycode){
    getCompanyInfo()
  }else{
    shopCompanyObj.value = companyInfoRef.value
  }

  getInfo()

})

</script>

<style scoped>

.full-width-overflow-y{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  text-align: left;
  position: relative;
}

@media screen and (min-width: 768px) {
  .icon-part-pc {
    width: calc(100% - 350px);
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .content-part-pc {
    width: 350px;
    height: 50%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .icon-position-pc {

  }

  .content-position-pc-1 {
    position: absolute;
    right: 0px;
    top: 0;
    height: 35%;
  }

  .content-position-pc-2 {
    position: absolute;
    right: 0px;
    top: 35%;
    height: 65%;
  }
}

.page-part {
  width: calc(100% - 30px);
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
  margin: auto;
}

.page-part-full {
  width: calc(100% - 30px);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
  margin: auto;
}

iframe {
  width: calc(100% + 2px);
  /* height: calc(100% + 163px); */
  height: calc(100% - 10px);
  border: none;
  margin-left: -1px;
}

.title-option-box {
  margin-bottom: 15px;
  text-align: left;
}

.title-part {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>